import ExternalStore from '@safe-global/utils/services/ExternalStore'

export const wcPopupStore = new ExternalStore<boolean>(false)

export function openWalletConnect() {
  wcPopupStore.setStore(true)
}
